import { render, staticRenderFns } from "./ProductionOrderFormUniqueBatchEmbeddable.vue?vue&type=template&id=5b5f5028&"
import script from "./ProductionOrderFormUniqueBatchEmbeddable.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderFormUniqueBatchEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports